import dayjs from "dayjs";

// Định nghĩa các hằng số để dễ quản lý bộ lọc
export const BRANCHES = ["Quận 1 - Đa Kao", "Quận 7 - Phú Mỹ Hưng", "Thủ Đức - Võ Văn Ngân"];
export const SUBJECTS = ["Toán", "Anh Văn", "Ngữ Văn", "Vật Lý", "Hóa Học"];
export const COURSES = ["Luyện thi Đại học", "Tiếng Anh Giao tiếp", "Lớp 10 Cơ bản", "Bồi dưỡng HSG"];

export const STATUS_COLORS = {
  scheduled: { label: "Chưa dạy", color: "bg-gray-100 text-gray-600 border-gray-300" },
  ongoing: { label: "Đang dạy", color: "bg-blue-100 text-blue-700 border-blue-300" },
  completed: { label: "Đã xong", color: "bg-green-100 text-green-700 border-green-300" },
  canceled: { label: "Nghỉ/Bù", color: "bg-red-100 text-red-700 border-red-300" },
};

export const SUBJECT_THEMES = {
  "Toán": { bg: "bg-indigo-50", text: "text-indigo-700", border: "border-indigo-200", accent: "#4F46E5" },
  "Anh Văn": { bg: "bg-rose-50", text: "text-rose-700", border: "border-rose-200", accent: "#E11D48" },
  "Ngữ Văn": { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", accent: "#10B981" },
  "Vật Lý": { bg: "bg-sky-50", text: "text-sky-700", border: "border-sky-200", accent: "#0EA5E9" },
  "Hóa Học": { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", accent: "#D97706" },
  default: { bg: "bg-gray-50", text: "text-gray-700", border: "border-gray-200", accent: "#6B7280" },
};

export const MOCK_EVENTS = [
  {
    id: 1,
    class: "TOAN-10A1",
    course: "Lớp 10 Cơ bản",
    subject: "Toán",
    teacher: "Thầy Nam",
    branch: "Quận 1 - Đa Kao",
    room: "P.302 (Lầu 3)",
    day: 1, // Thứ 2
    start: 8,
    end: 10,
    status: "completed",
    students: 25,
    note: "Kiểm tra 15p đầu giờ"
  },
  {
    id: 2,
    class: "ENG-IELTS-01",
    course: "Tiếng Anh Giao tiếp",
    subject: "Anh Văn",
    teacher: "Cô Lan",
    branch: "Quận 7 - Phú Mỹ Hưng",
    room: "P.102",
    day: 1,
    start: 10,
    end: 12,
    status: "ongoing",
    students: 12,
    note: "Học với GV bản ngữ"
  },
  {
    id: 3,
    class: "LY-12C3",
    course: "Luyện thi Đại học",
    subject: "Vật Lý",
    teacher: "Thầy Vinh",
    branch: "Quận 1 - Đa Kao",
    room: "P.201",
    day: 2, // Thứ 3
    start: 14,
    end: 16,
    status: "scheduled",
    students: 40,
    note: ""
  },
  {
    id: 4,
    class: "VAN-11B2",
    course: "Bồi dưỡng HSG",
    subject: "Ngữ Văn",
    teacher: "Cô Hoa",
    branch: "Thủ Đức - Võ Văn Ngân",
    room: "Phòng Hội Thảo",
    day: 3, // Thứ 4
    start: 8,
    end: 10,
    status: "scheduled",
    students: 15,
    note: "Chuẩn bị tài liệu ôn thi tỉnh"
  },
  {
    id: 5,
    class: "HOA-12A2",
    course: "Luyện thi Đại học",
    subject: "Hóa Học",
    teacher: "Thầy Minh",
    branch: "Quận 7 - Phú Mỹ Hưng",
    room: "Lab 01",
    day: 4, // Thứ 5
    start: 16,
    end: 18,
    status: "scheduled",
    students: 30,
    note: "Thực hành hóa hữu cơ"
  },
  {
    id: 6,
    class: "TOAN-9C1",
    course: "Lớp 9 Cơ bản",
    subject: "Toán",
    teacher: "Thầy Nam",
    branch: "Quận 1 - Đa Kao",
    room: "P.305",
    day: 5, // Thứ 6
    start: 8,
    end: 10,
    status: "scheduled",
    students: 20,
    note: ""
  }
];